import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import Dashboard from '@/views/Dashboard';
import Login from '@/views/Login';
import SelectProperty from '@/views/SelectProperty';
import NotFound from '@/views/NotFound';
import ForgotPassword from '@/views/ForgotPassword';
import PasswordReset from '@/views/PasswordReset';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
    meta: { guest: true }
  },
  {
    path: '/dashboard/:siteId?/:startDate?/:endDate?/:leadId?',
    name: 'Dashboard',
    component: Dashboard,
    meta: {requiresAuth: true},
  },
  {
    path: '/select-property',
    name: 'Select your Property',
    component: SelectProperty,
    meta: {requiresAuth: true},
  },
  {
    path: '/forgot-password',
    name: 'Forgot Password',
    component: ForgotPassword
  },
  {
    path: '/password-reset/*',
    name: 'Password Reset',
    component: PasswordReset
  },
  {
    path: '*',
    component: NotFound
  }
];

const router = new Router({
  mode: "history",
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (store.getters.isAuthenticated) {
      console.log('user',store.getters.StateUser.isFirstLogin);
      //if(store.getters.StateUser.isFirstLogin === false)
      next();
      return;
    }
    next({path:'/',params:{siteId:to.params.siteId},query:{'redirect':to.fullPath}});
  } else {
    next();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.guest)) {
    if (store.getters.isAuthenticated) {
      next('/select-property');
      return;
    }
    next();
  } else {
      next();
  }
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js